/**
 * Redux middleware for Sentry v10+
 * Replacement for deprecated redux-sentry-middleware
 */

const createSentryMiddleware = (Sentry, options = {}) => {
  const {
    breadcrumbDataFromAction = () => undefined,
    actionTransformer = action => action,
    stateTransformer = state => state,
    breadcrumbCategory = 'redux-action',
    filterBreadcrumbActions = () => true,
  } = options;

  return store => next => action => {
    // Add breadcrumb for this action
    if (filterBreadcrumbActions(action)) {
      const breadcrumbData = breadcrumbDataFromAction(action);
      Sentry.addBreadcrumb({
        category: breadcrumbCategory,
        message: action.type,
        level: 'info',
        data: breadcrumbData,
      });
    }

    // Set redux state context
    try {
      const state = store.getState();
      const transformedState = stateTransformer(state);
      Sentry.setContext('redux_state', transformedState);
    } catch (err) {
      // Ignore errors in state transformation
    }

    // Set last action context
    try {
      const transformedAction = actionTransformer(action);
      Sentry.setContext('redux_action', transformedAction);
    } catch (err) {
      // Ignore errors in action transformation
    }

    return next(action);
  };
};

export default createSentryMiddleware;
